import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';

// CRITICAL: Handle logout before ANY React code runs
const currentPath = window.location.pathname;

console.log('INDEX.TSX - Initial load');
console.log('Current path:', currentPath);
console.log('Full URL:', window.location.href);

if (currentPath === '/logout') {
  console.log('LOGOUT PATH DETECTED - Clearing storage immediately');
  console.log('Token before:', localStorage.getItem('authToken'));

  // Clear storage
  localStorage.clear();
  sessionStorage.clear();

  console.log('Token after:', localStorage.getItem('authToken'));

  // Get email parameter
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get('email');

  const redirectUrl = email
    ? `/login?email=${encodeURIComponent(email)}`
    : '/login';

  console.log('Redirecting to:', redirectUrl);

  // Immediate redirect - don't wait for React
  window.location.replace(redirectUrl);

  // Stop execution here - don't render React
  throw new Error('Redirecting to login...');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

reportWebVitals();
